import React, { useMemo } from "react"
import Label, { useLabels } from "components/general/Label";
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Stack } from 'react-bootstrap'
import Noc from "components/presentation/Noc";
import { isParalympic, CompetitionFromStore, getDateTimeFormat } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';
import Gender from "components/presentation/Gender";
import DateTime from "components/presentation/DateTime";
import RegisteredEvents from "components/presentation/RegisteredEvents";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const getConfiguration = (breakPoint) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = isMobile ? [{ id: "NOCAndName", desc: false }] : [{ id: 'NOC', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM() : TableColumns()
  return configuration;
};


const SportEntriesAthletesTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const config = useMemo(() => getConfiguration(breakPoint), [breakPoint]);
  const fLabel = useLabels();
  return (
    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='eventUnit-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-athletes`}
      showPagination={true}
      summaryDesc={fLabel({ data: 'SummaryEntriesPage' })}
    // pageSizeCustom={10}
    />
  )
}

export default SportEntriesAthletesTable;

function TableColumns() {
  return (
    [
      ColumnNoc({ label: "HeaderNOC" }),
      ColumnGender({}),
      ColumnCompetitor({}),
      ColumnDOB({}),
      ColumnEvent({}),
    ]
  )
}

function TableColumnsSM() {
  return (
    [
      ColumnCompetitorWithDOBAndGenderAndNOC({}),
      ColumnEvent({}),
    ]
  )
}

export function ColumnDiscipline({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start w-30',
  label = "HeaderDiscipline"

}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      accessor: 'code',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Discipline',
      Cell: (props) => {
        let disciplineDes = props.cell.row.original?.disciplines?.find(x => x !== undefined)

        return (
          <Discipline code={disciplineDes?.code} description={disciplineDes?.description} />
        )
      }
    }
  )
}

export function ColumnDisciplineNew({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start w-30',
  label = "HeaderDiscipline"

}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      accessor: 'code',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Discipline',
      Cell: (props) => {
        const row = props.cell.row.original;
        const disciplines = row?.disciplines;
        return (
          <div>
            {disciplines?.map((discipline, index) => (
              <div key={index}>
                <Discipline code={discipline?.code} description={discipline?.description} />
              </div>
            ))}
          </div>
        )
      }
    }
  )
}

export function ColumnNoc({
  disableSort = false,
  className = 'text-start',
  headerClassName = 'text-start w-20',
  label = 'HeaderNOC',
  remove = false
}) {

  const competition = CompetitionFromStore();
  if (isParalympic(competition) && label === 'HeaderNOC') {
    label = 'HeaderNPC';
  }

  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'NOC',
      accessor: 'organisation.description',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      remove: remove,
      Cell: (props) => {
        let data = props.cell.row.original?.organisation
        return (<Noc {...data} showLongDesc={true} />)
      }
    }
  )

}
export function ColumnGender({

  disableSort = true,
  className = 'text-center',
  headerClassName = 'text-center',
  label = 'HeaderGender',
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'Gender',
      accessor: 'personGender',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      Cell: (props) => {
        let data = props.cell.row.original?.personGender
        return (<Gender {...data} onlyDesc='ture' />)
      }
    }
  )

}

export function ColumnDOB({

  disableSort = true,
  className = 'text-center',
  headerClassName = 'text-center text-nowrap',
  label = 'HeaderBirthDate',
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'DOB',
      accessor: 'birthDate',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      Cell: (props) => {
        const formatDateTime = getDateTimeFormat('DayMonthShortYear');
        let { birthDate } = props.cell.row.original;
        return (<DateTime datetime={birthDate} format={formatDateTime} />)
      }
    }
  )

}

export function ColumnEvent({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-nowrap text-start',
  label = 'HeaderEvent',
}) {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'Event',
      accessor: 'registeredEvents',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      Cell: (props) => {
        const data = props.cell.row.original;
        let events = data?.registeredEvents;
        return (<RegisteredEvents discCode={mirs_discipline} events={events} />)
      }
    }
  )
}

export function ColumnCompetitorWithDOBAndGenderAndNOC({
  disableSort = false,
}) {
  const competition = CompetitionFromStore();
  let nocLabel = "HeaderNOC";
  if (isParalympic(competition)) {
    nocLabel = 'HeaderNPC';
  }
  return (
    {
      Header: <Stack direction='vertical'>
        <Label data={"LabelName"} />
        <Stack direction="horizontal">
          <Label data={"HeaderBirthDate"} />
          <span> / </span>
          <Label data={"HeaderGender"} />
        </Stack>
        <Label data={nocLabel} />
      </Stack>,
      accessor: (props) => ((props?.organisation?.code || " ") + (props?.name?.toUpperCase() || "")),
      className: '',
      headerClassName: '',
      disableSortBy: disableSort,
      id: 'NOCAndName',
      Cell: (props) => {
        const row = props.cell.row.original
        const formatDateTime = getDateTimeFormat('DayMonthShortYear');
        return (
          <Stack direction='vertical'>
            <Competitor {...row} hideNoc={true} hidePicture={false} key={`participant-${row?.code}`} />
            <Stack gap={1} direction='horizontal'>
              <DateTime datetime={row?.birthDate} format={formatDateTime} />
              <span>/</span>
              <Gender code={row?.personGender?.code} />
            </Stack>
            <Noc {...row?.organisation} showLongDesc={false} />
          </Stack>
        )
      }
    }
  )
}

export function ColumnCompetitor({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start',
  label = "LabelName"
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'Competitor',
      accessor: (props) => (props?.name?.toUpperCase()),
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <Competitor {...row} hideNoc={true} hidePicture={false} key={`participant-${row?.code}`} />
        )
      }
    }
  )
}